// Copyright (c) 2024 Deere & Company

import FactoryDuplicatePinPlates, {getDefaultState} from '../state/factory-duplicate-pin-plate';
import actions from '../../actions-list';

const updateFactoryDuplicatePlateResults = (state, action) =>
FactoryDuplicatePinPlates.update(state, {
    $set: action.data
});

const updateSelectedPinPlates = (state, action) => {

    const updatedState = [...state];

    return updatedState.map(pinPlate => {

        if (action.data[pinPlate.id]) {

            return {...pinPlate, selected: action.data[pinPlate.id]};

        }
        return pinPlate;

    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_FACTORY_PIN_PLATE_RESULTS]: updateFactoryDuplicatePlateResults,
        [actions.UPDATE_FACTORY_PIN_PLATE_SELECTED_ITEMS]: updateSelectedPinPlates
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/reducers/factory-duplicate-pin-plates.js